var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66132 10.5769L5.66132 11C5.88571 11 6.10127 10.9086 6.26022 10.7434C6.57655 10.414 6.58028 9.88729 6.26913 9.55262L2.49606 5.49982L6.26908 1.44708C6.58032 1.11288 6.57659 0.585948 6.25997 0.256267C5.92757 -0.0892596 5.38037 -0.0847377 5.05379 0.265943L0.730462 4.90967C0.423141 5.24029 0.423141 5.75936 0.730691 6.09022L5.05361 10.7335C5.21274 10.9046 5.43232 11 5.66132 11L5.66132 10.5769Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.85f81a9e7234b503ab2321214f7f446a.svg";
export { ForwardRef as ReactComponent };